// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".codeViewer_jsFYU{box-sizing:border-box;-webkit-font-smoothing:antialiased;display:flex;justify-content:center}code{font-family:Consolas,Monaco,\"Andale Mono\",\"Lucida Console\",monospace;-webkit-hyphens:none;-ms-hyphens:none;hyphens:none;font-size:16px;font-weight:400;text-align:left}", ""]);
// Exports
exports.locals = {
	"codeViewer": "codeViewer_jsFYU"
};
module.exports = exports;
